<div class="wa-stack">
  <form>
    <div class="wa-split wa-align-items-end">
      <div class="wa-cluster">
        <wa-input label="Last name"
                  type="text"
                  [formControl]="lastNameFilter"
                  placeholder="last name">
        </wa-input>
      </div>
      <div>
        <wa-button variant="brand" (click)="resetFilter()">
          <wa-icon name="filter-slash" variant="solid" label="filter"></wa-icon>
          reset filters
        </wa-button>
      </div>
    </div>
  </form>
  @if (staffmembers.isLoading()) {
    <wa-callout variant="neutral">
      <wa-spinner slot="icon"></wa-spinner>
      Please wait while we load the staff members for the selected semester.
    </wa-callout>
  } @else {
    @if (!staffMembersView() || staffMembersView().length === 0) {
      @if (user()?.isAdmin) {
        <wa-callout variant="warning">
          <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
          <strong>No staff members found for current filter setting</strong><br/>
        </wa-callout>
      }
      @if (!user()?.isAdmin || filter !== defaultFilter) {
        <wa-callout variant="warning">
          <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
          <strong>No staff members found.</strong><br/>
          Currently, no staff members are available for the selected semester.
        </wa-callout>
      }
    }
  }
  @if (staffmembers.hasValue()) {
    <wa-divider></wa-divider>
    <wa-scroller orientation="vertical" class="survey-scroller">
      <div class="wa-stack" style="--min-column-size: 30ch;">
        @for (staffmember of staffMembersView(); track staffmember.id) {
          <app-staffmember-list-element
            [staffmember]="staffmember"
            [showSupervisionGradingControls]="!!user() && user()!.isAdmin"
            (editCorrections)="editCorrections($event)"
            (editSupervisions)="editSupervisions($event)"
            (displayAssignments)="displayAssignments($event)">
          </app-staffmember-list-element>
        }
      </div>
    </wa-scroller>
  }

  <!-- Loading overlay, shown while dialog data is prepared -->
  @if (isLoading()) {
    <div class="loading-overlay">
      <div class="wa-stack">
        <h3 class="loading-text">Reading assignments…</h3>
        <wa-progress-bar indeterminate></wa-progress-bar>
      </div>
    </div>
  }
</div>
